import { render, staticRenderFns } from "./access_denied.vue?vue&type=template&id=128b8fa6&scoped=true&"
import script from "./access_denied.vue?vue&type=script&lang=js&"
export * from "./access_denied.vue?vue&type=script&lang=js&"
import style0 from "./access_denied.vue?vue&type=style&index=0&id=128b8fa6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "128b8fa6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VMain } from 'vuetify/lib/components/VMain';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VMain,VRow})
